import MyBookmarksLayout from '@components/Pages/Profile/MyBookmarks/MyBookmarksLayout'
import PageMetadata from '@components/Shared/PageMetadata'
import siteMetadata from '@data/siteMetadata.json'

const title = 'My Bookmarks'
const metadata = siteMetadata.routes['My Profile'].routes[title]
const metadataPage: Metadata = {
    url: siteMetadata.siteUrl + metadata.url,
    title: `${title} | ${siteMetadata.title}`,
    description: metadata.description,
}

const MyBookmarksPage = () => {
    return (
        <div className="p-semilarge">
            <PageMetadata {...metadataPage} />
            <MyBookmarksLayout />
        </div>
    )
}

export default MyBookmarksPage
